document.addEventListener("DOMContentLoaded", function () {
  window.dataLayer = window.dataLayer || [];

  function sendPageViewEvent() {
    if (!window.GTMData) {
      console.warn("GTMData non definito");
      return;
    }

    window.dataLayer.push({
      event: "viewpage",
      page_path: window.location.pathname,
      full_url: window.location.origin + window.location.pathname,
      page_host: window.location.hostname,
      login_status: window.GTMData.login_status,
      user_id: window.GTMData.user_id,
      is_logged_user: window.GTMData.is_logged_user,
      hashed_email: window.GTMData.hashed_email,
      store_country: window.GTMData.store_country,
      store_language: window.GTMData.store_language,
    });
  }

  sendPageViewEvent();
  window.__viewpageSent = true;
  (window.__viewpageQueue || []).forEach(function(fn) { fn(); });
  window.__viewpageQueue = [];

  document.addEventListener("shopify:section:load", sendPageViewEvent);
  document.addEventListener("shopify:page:load", sendPageViewEvent);
  window.addEventListener("popstate", sendPageViewEvent);

  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.formId !== "QRSVUy") return;
    if (e.detail.type !== "submit" && e.detail.type !== "stepSubmit") return;
    if (window.__newsletterSent_QRSVUy) return;
    window.__newsletterSent_QRSVUy = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "newsletter_subscription",
      page_path: window.location.pathname,
      full_url: window.location.origin + window.location.pathname,
      login_status: window.GTMData ? window.GTMData.login_status : "",
      user_id: window.GTMData ? window.GTMData.user_id : "",
      is_logged_user: window.GTMData ? window.GTMData.is_logged_user : false,
      store_country: window.GTMData ? window.GTMData.store_country : "",
      store_language: window.GTMData ? window.GTMData.store_language : "",
    });
  });
});
